// extracted by mini-css-extract-plugin
export default {"page":"transactionpage_page__PMV1y","transactionBlock":"transactionpage_transactionBlock__a9YnD"};